import * as Immutable from 'immutable';
import { handleActions } from 'redux-actions';

import { EventsActionType, EventsStore } from './EventsReducer.types';

// @ts-ignore
const initialState: EventsStore = Immutable.fromJS({
  data: Immutable.List(),
  isFetching: false,
  failure: false,
});

const EventsReducer = handleActions(
  {
    DASHBOARD_EVENTS_REQUEST: (state: EventsStore) => state.set('isFetching', true),

    DASHBOARD_EVENTS_RESPONSE_FAILURE: (state: EventsStore) => state.set('isFetching', false).set('failure', true),

    AUTHENTICATION_LOGOUT: () => initialState,

    DASHBOARD_EVENTS_RESPONSE: (state: EventsStore, action: EventsActionType) =>
      state.set('isFetching', false).set('data', Immutable.fromJS(action.payload.data.results)).set('failure', false),
  },
  initialState
);

export default EventsReducer;
